import {TimeCheckPoints} from "@nolimitcity/slot-game/bin/utils/TimeCheckPoints";
import {AnimatedParticle, Emitter, OldEmitterConfig} from "pixi-particles";
import {WalkOfShame} from "../../WalkOfShame";

export class ParticleController {
    private _deltaTime: number = 0;
    private readonly _emitter: Emitter;

    constructor(layer: PIXI.Container, type: string = "Particles", texturePath: string, config: OldEmitterConfig, loops?: boolean) {
        this.timeName = type;
        this._emitter = new Emitter(layer, [{
            framerate: 30,
            loop: !!loops,
            hasLoaded: true,
            textures: WalkOfShame.assetLoader.getTextures(texturePath)
        }], config);
        this._emitter.particleConstructor = AnimatedParticle;
        this._emitter.emit = false;
    }

    get emitter(): Emitter {
        return this._emitter;
    }

    public set visible(value: boolean) {
        if (!value) {
            this._emitter.cleanup();
        }
    }

    private _timeName: string = "Particles";

    private get timeName(): string {
        return this._timeName;
    }

    private set timeName(name: string) {
        this._timeName = name;
        TimeCheckPoints.setCheckPoint(name);
    }

    private get elapsedTime(): number {
        return TimeCheckPoints.getCheckPointTime(this.timeName);
    }

    public update(): void {
        this._emitter.update((this.elapsedTime - this._deltaTime) * 0.001);
        this._deltaTime = this.elapsedTime;
    }

    public enableEmit(value: boolean): void {
        this._emitter.emit = value;
    }

    public setPos(newPos: PIXI.Point): void {
        this._emitter.spawnPos.copyFrom(newPos);
    }

    public remove(): void {
        this.visible = false;
        this._emitter.destroy();
        TimeCheckPoints.removeChekPoint(this.timeName);
    }
}